var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.005 512.005",
    style: {
      enableBackground: "new 0 0 512.005 512.005"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.003,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 53.895
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.003,
    y: 458.11,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 53.895
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.003,
    y: 53.895,
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 404.21
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M397.75,147.023c110.799,175.788-74.937,361.524-250.725,250.725  c-13.228-8.338-24.433-19.542-32.77-32.77C3.457,189.189,189.191,3.454,364.979,114.252  C378.208,122.59,389.413,133.794,397.75,147.023z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M222.393,348.104l-27.021,4.504c-3.406,0.568-6.507-2.059-6.507-5.512v-10.168h33.528V348.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M289.449,348.104l27.021,4.504c3.406,0.568,6.507-2.059,6.507-5.512v-10.168h-33.528   L289.449,348.104L289.449,348.104z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M250.333,166.326h-2.336c-2.805,0-5.326-1.561-6.581-4.065l-4.134-8.267l3.749-1.877l4.134,8.267   c0.54,1.08,1.626,1.752,2.832,1.752h2.336V166.326z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.891,
    y: 163.47,
    transform: "matrix(0.4472 0.8944 -0.8944 0.4472 263.4179 -95.0869)",
    style: {
      fill: "#965032"
    },
    width: 15.491,
    height: 4.193
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M263.604,230.757l-11.452-11.449c-2.488-2.488-3.915-5.932-3.915-9.452v-3.853   c0-1.413-0.336-2.832-0.969-4.098l-2.854-5.708c-0.595-1.19-1.793-1.932-3.124-1.932h-9.855c-2.93,0-5.563-1.626-6.873-4.246   l-4.044-8.087l3.749-1.877l4.044,8.087c0.595,1.19,1.793,1.932,3.124,1.932h9.855c2.93,0,5.563,1.626,6.873,4.246l2.854,5.708   c0.922,1.85,1.411,3.913,1.411,5.975v3.853c0,2.417,0.98,4.78,2.688,6.483l4.297,4.3v-19.525c0-5.293-1.823-10.483-5.13-14.619   c-3.899-4.879-6.046-10.996-6.046-17.239v-16.202h4.191v16.202c0,5.293,1.823,10.483,5.13,14.619   c3.899,4.879,6.046,10.996,6.046,17.239V230.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M253.635,219.919h-6.221c-3.836,0-7.31-2.417-8.647-6.008l-1.574-4.246l3.929-1.462l1.574,4.246   c0.729,1.965,2.625,3.28,4.718,3.28h6.221V219.919z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#965032"
    },
    points: "251.062,201.813 247.225,200.121 270.767,146.621 274.603,148.312  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#965032"
    },
    points: "280.367,194.266 260.112,194.266 260.112,190.075 276.177,190.075 276.177,169.818    280.367,169.818  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M245.355,214.522h-23.574c-2.749,0-4.977-2.228-4.977-4.977v-6.81c0-2.749,2.228-4.977,4.977-4.977   h23.574c2.749,0,4.977,2.228,4.977,4.977v6.81C250.333,212.294,248.105,214.522,245.355,214.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M284.471,214.522h-23.574c-2.749,0-4.977-2.228-4.977-4.977v-6.81c0-2.749,2.228-4.977,4.977-4.977   h23.574c2.749,0,4.977,2.228,4.977,4.977v6.81C289.449,212.294,287.22,214.522,284.471,214.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M301.236,197.758h-29.162c-2.749,0-4.977-2.228-4.977-4.977v-6.81c0-2.749,2.228-4.977,4.977-4.977   h29.162c2.749,0,4.977,2.228,4.977,4.977v6.81C306.212,195.53,303.984,197.758,301.236,197.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M306.824,175.406h-45.926c-2.749,0-4.977-2.228-4.977-4.977v-6.81c0-2.749,2.228-4.977,4.977-4.977   h45.926c2.749,0,4.977,2.228,4.977,4.977v6.81C311.801,173.178,309.573,175.406,306.824,175.406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M284.471,153.054h-17.986c-2.749,0-4.977-2.228-4.977-4.977v-6.81c0-2.749,2.228-4.977,4.977-4.977   h17.986c2.749,0,4.977,2.228,4.977,4.977v6.81C289.449,150.826,287.22,153.054,284.471,153.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M211.829,164.23h-12.398c-2.749,0-4.977-2.228-4.977-4.977v-6.81c0-2.749,2.228-4.977,4.977-4.977   h12.398c2.749,0,4.977,2.228,4.977,4.977v6.81C216.805,162.002,214.577,164.23,211.829,164.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M250.943,158.642h-23.574c-2.749,0-4.977-2.228-4.977-4.977v-6.81c0-2.749,2.228-4.977,4.977-4.977   h23.574c2.749,0,4.977,2.228,4.977,4.977v6.81C255.921,156.414,253.693,158.642,250.943,158.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M245.355,186.582h-40.338c-2.749,0-4.977-2.228-4.977-4.977v-6.81c0-2.749,2.228-4.977,4.977-4.977   h40.338c2.749,0,4.977,2.228,4.977,4.977v6.81C250.333,184.354,248.105,186.582,245.355,186.582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M339.741,303.4H172.102c-6.172,0-11.176,5.003-11.176,11.176c0,6.172,5.004,11.176,11.176,11.176   h44.704c0,6.172,5.004,11.176,11.176,11.176h55.88c6.172,0,11.176-5.004,11.176-11.176h44.704c6.172,0,11.176-5.004,11.176-11.176   C350.917,308.404,345.913,303.4,339.741,303.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE7855"
    },
    d: "M367.331,204.214c-0.417-0.838-2.598,0.157-3.958-0.349c-16.881-6.276-39.547-17.707-54.361-25.501  l-2.974-4.709l-28.08-13.648c-1.787-0.869-3.941-0.201-4.924,1.527l-1.384,2.434c-1.056,1.857-0.359,4.22,1.537,5.206l26.739,13.911  l7.556-0.559l29.367,15.098c0,0,19.952,10.206,21.013,10.956s1.669,4.947,3.648,4.598  C362.926,212.928,369.138,207.845,367.331,204.214z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE3C"
    },
    d: "M182.113,311.782c0,0,1.863,8.266,0.116,9.197c-1.746,0.931-11.06,0.931-10.827-1.048   s1.513-8.964,1.513-8.964L182.113,311.782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE3C"
    },
    d: "M197.596,307.358c0,0-1.513,6.17,1.513,6.403c3.027,0.233,20.14,0.116,20.606-0.349   c0.466-0.466,1.048-1.63,1.048-1.63l-15.833-4.424L197.596,307.358L197.596,307.358z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF3F5"
    },
    d: "M180.221,230.407c0,0-4.162,9.895-5.675,44.18c-0.403,9.122,0.698,6.985-3.842,36.322l5.388,2.813  c1.569,0.819,3.453,0.759,4.967-0.158l5.245-3.179c0,0-2.561-32.829,5.821-51.689c0,0,4.424,8.149,4.424,14.203  c0,6.054-0.233,35.158-0.233,35.158s9.779,1.63,14.203,1.164c0,0-2.794-63.156-5.588-78.028L180.221,230.407z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M181.007,226.216c0,0-1.659,1.222-0.786,4.191c0,0,12.748,5.501,24.709,0.786   c0,0,1.31-1.921-0.349-4.278L181.007,226.216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M163.952,195.948c-7.255,2.697-18.277,9.43-17.579,14.785c0.699,5.355,4.494,4.049,5.677,2.734   s4.583-5.535,5.644-6.284c1.061-0.75,18.219-9.559,18.219-9.559l45.431-23.358c0,0,0.349-2.27-2.357-4.104   C218.988,170.162,191.193,185.82,163.952,195.948z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE3C"
    },
    d: "M185.372,169.638l-0.262,1.921c0,0-0.698,12.311,3.318,15.629c0,0,0.873,2.532-0.524,3.754  s-15.192,8.207-15.192,8.207s-3.58,7.422-3.492,11.613c0,0-3.405-1.31-3.056-2.969s2.357-6.025,1.746-8.12s-2.881-1.484-2.881-1.484  s-1.135,1.222,0.698,2.008l-0.611,2.619l-7.422,4.366l1.659,2.008c0,0,0.087,15.367,9.168,17.375c0,0,4.802,0.349,10.477-10.477  c0,0,3.056,5.413,2.008,10.128c0,0,9.954,5.413,23.574,0.698l0.175-9.43c0,0,2.095,14.494,9.255,13.097  c0,0,19.833-7.634,16.531-10.536c-7.683-6.752-16.961-1.046-16.961-1.046c-0.45-9.808-1.271-22.494-2.538-23.867  c-2.095-2.27-8.557-1.048-9.837-3.958s-0.931-8.033,0.466-13.97s-5.704-10.128-5.704-10.128L185.372,169.638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M185.111,171.559c0,0,7.13,1.804,12.718-0.407l2.445,6.054h1.397c0,0,3.366-11.203-1.104-11.072  c0,0-0.017-3.637-7.823-3.484C186.038,162.781,183.714,167.135,185.111,171.559z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M330.65,311.782c0,0-1.863,8.266-0.116,9.197c1.746,0.931,11.06,0.931,10.827-1.048   s-1.513-8.964-1.513-8.964L330.65,311.782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M315.167,307.358c0,0,1.513,6.17-1.513,6.403c-3.027,0.233-20.14,0.116-20.606-0.349   c-0.466-0.466-1.048-1.63-1.048-1.63l15.833-4.424L315.167,307.358L315.167,307.358z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF3F5"
    },
    d: "M332.542,230.407c0,0,4.162,9.895,5.675,44.18c0.403,9.122-0.698,6.985,3.842,36.322l-5.388,2.813  c-1.569,0.819-3.453,0.759-4.967-0.158l-5.245-3.179c0,0,2.561-32.829-5.821-51.689c0,0-4.424,8.149-4.424,14.203  c0,6.054,0.233,35.158,0.233,35.158s-9.779,1.63-14.203,1.164c0,0,2.794-63.156,5.588-78.028L332.542,230.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE7855"
    },
    d: "M331.755,226.216c0,0,1.659,1.222,0.786,4.191c0,0-12.748,5.501-24.709,0.786  c0,0-1.31-1.921,0.349-4.278L331.755,226.216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M327.391,169.638l0.262,1.921c0,0,0.699,12.311-3.318,15.629c0,0-0.873,2.532,0.524,3.754  c1.397,1.222,15.192,8.207,15.192,8.207s3.58,7.422,3.492,11.613c0,0,3.405-1.31,3.056-2.969s-2.357-6.025-1.746-8.12  s2.881-1.484,2.881-1.484s1.135,1.222-0.699,2.008l0.611,2.619l7.422,4.366l-1.659,2.008c0,0-0.087,15.367-9.168,17.375  c0,0-4.802,0.349-10.477-10.477c0,0-3.056,5.413-2.008,10.128c0,0-9.954,5.413-23.574,0.698l-0.175-9.43  c0,0-2.095,14.494-9.255,13.097c0,0-19.833-7.634-16.531-10.536c7.683-6.752,16.961-1.046,16.961-1.046  c0.45-9.808,1.271-22.494,2.538-23.867c2.095-2.27,8.557-1.048,9.837-3.958s0.931-8.033-0.466-13.97s5.704-10.128,5.704-10.128  L327.391,169.638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M327.652,171.559c0,0-7.13,1.804-12.718-0.407l-2.445,6.054h-1.397c0,0-3.366-11.203,1.104-11.072  c0,0,0.017-3.637,7.823-3.484C326.724,162.781,329.049,167.135,327.652,171.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF3F5"
    },
    d: "M207.865,176.225c-0.583-1.418,0.394-1.808,0.394-1.808s7.067-3.879,7.889-3.813  c1.359,0.11,3.024,2.498,3.024,4.536s2.654,7.328,8.111,8.643c0,0-6.81,9.255-16.263,7.99  C211.02,191.772,211.654,185.442,207.865,176.225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M217.77,219.581c-2.094,0-3.792,1.811-3.792,4.044v46.247c0,11.176,5.239,50.292,41.91,61.468  c36.671-11.176,41.91-50.292,41.91-61.468v-46.247c0-2.234-1.698-4.044-3.792-4.044H217.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M297.798,269.872v-46.247c0-2.234-1.697-4.044-3.792-4.044h-38.118v39.116l36.838,36.838  C296.803,284.769,297.798,274.706,297.798,269.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF3F5"
    },
    d: "M213.978,269.872v-46.247c0-2.234,1.697-4.044,3.792-4.044h38.118v39.116l-36.837,36.838  C214.971,284.769,213.978,274.706,213.978,269.872z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8C5A28"
    },
    points: "231.174,294.338 240.87,304.593 267.879,304.593 273.604,297.254 267.018,299.889   245.191,299.889 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M241.617,281.104l-1.48,14.928l-6.737-2.572C233.4,293.46,236.499,286.266,241.617,281.104z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 254.91,
    y: 275.19,
    style: {
      fill: "#8C5A28"
    },
    width: 0.996,
    height: 25.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.12,
    y: 277.34,
    style: {
      fill: "#8C5A28"
    },
    width: 0.996,
    height: 23.269
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.73,
    y: 277.34,
    style: {
      fill: "#8C5A28"
    },
    width: 0.996,
    height: 23.269
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M259.108,298.195h-7.391c-0.271,0-0.491-0.22-0.491-0.491v-4.381c0-0.271,0.22-0.491,0.491-0.491   h7.391c0.271,0,0.491,0.22,0.491,0.491v4.381C259.599,297.975,259.379,298.195,259.108,298.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M259.108,291.045h-7.391c-0.271,0-0.491-0.22-0.491-0.491v-4.381c0-0.271,0.22-0.491,0.491-0.491   h7.391c0.271,0,0.491,0.22,0.491,0.491v4.381C259.599,290.825,259.379,291.045,259.108,291.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M259.108,284.459h-7.391c-0.271,0-0.491-0.22-0.491-0.491v-4.381c0-0.271,0.22-0.491,0.491-0.491   h7.391c0.271,0,0.491,0.22,0.491,0.491v4.381C259.599,284.239,259.379,284.459,259.108,284.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M267.754,298.195h-6.262c-0.271,0-0.491-0.22-0.491-0.491v-4.381c0-0.271,0.22-0.491,0.491-0.491   h6.262c0.271,0,0.491,0.22,0.491,0.491v4.381C268.245,297.975,268.026,298.195,267.754,298.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M267.754,291.612h-6.262c-0.271,0-0.491-0.22-0.491-0.491v-3.54c0-0.271,0.22-0.491,0.491-0.491   h6.262c0.271,0,0.491,0.22,0.491,0.491v3.54C268.245,291.392,268.026,291.612,267.754,291.612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M267.754,285.086h-6.262c-0.271,0-0.491-0.22-0.491-0.491v-2.814c0-0.271,0.22-0.491,0.491-0.491   h6.262c0.271,0,0.491,0.22,0.491,0.491v2.814C268.245,284.867,268.026,285.086,267.754,285.086z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M249.359,298.195h-6.262c-0.271,0-0.491-0.22-0.491-0.491v-4.381c0-0.271,0.22-0.491,0.491-0.491   h6.262c0.271,0,0.491,0.22,0.491,0.491v4.381C249.85,297.975,249.63,298.195,249.359,298.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M249.359,291.612h-6.262c-0.271,0-0.491-0.22-0.491-0.491v-3.54c0-0.271,0.22-0.491,0.491-0.491   h6.262c0.271,0,0.491,0.22,0.491,0.491v3.54C249.85,291.392,249.63,291.612,249.359,291.612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M249.359,285.086h-6.262c-0.271,0-0.491-0.22-0.491-0.491v-2.814c0-0.271,0.22-0.491,0.491-0.491   h6.262c0.271,0,0.491,0.22,0.491,0.491v2.814C249.85,284.867,249.63,285.086,249.359,285.086z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "264.121,277.343 264.121,280.35 259.694,278.819  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "245.738,277.343 245.738,280.35 241.313,278.819  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "254.947,275.182 254.947,278.189 250.521,276.659  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M289.15,303.4h-66.523c0.991,1.884,2.077,3.751,3.297,5.588h59.929  C287.073,307.151,288.159,305.284,289.15,303.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M285.853,308.988h-59.929l0,0c2.647,3.984,5.891,7.768,9.781,11.176h40.368  C279.962,316.756,283.206,312.972,285.853,308.988L285.853,308.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M235.704,320.164c5.363,4.698,11.944,8.664,20.184,11.176c8.24-2.512,14.821-6.477,20.184-11.176  H235.704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE7855"
    },
    d: "M248.71,261.98c0,0-0.41,0.143-0.849,0.093c-0.34-0.146-1.036-0.169-0.616-1.459  c0.204-0.64,0.632-1.542,0.321-1.776c-0.251-0.291-0.523-0.606-0.813-0.942c-0.58-0.672-1.235-1.431-1.95-2.258  c-1.468-1.618-3.208-3.478-5.237-5.312c-1.013-0.919-2.059-1.869-3.122-2.834c-1.101-0.929-2.119-1.969-3.319-2.834  c-0.679-0.357-1.541-0.536-2.295-0.815c-0.736-0.297-1.197-0.856-1.736-1.33c-1.054-0.974-2.092-1.932-3.096-2.859  c-2.039-1.825-3.829-3.637-5.361-5.192c-1.485-1.485-2.686-2.776-3.532-3.716c-0.807-0.896-0.756-2.258,0.111-3.096l2.483-2.396  c0.868-0.837,2.231-0.839,3.098-0.001c0.91,0.88,2.157,2.126,3.588,3.663c1.5,1.587,3.247,3.441,4.997,5.543  c0.891,1.037,1.811,2.108,2.746,3.197c0.455,0.556,0.997,1.036,1.268,1.783c0.252,0.764,0.401,1.632,0.733,2.323  c0.821,1.23,1.824,2.284,2.713,3.418c0.927,1.097,1.838,2.176,2.721,3.221c1.76,2.094,3.557,3.899,5.121,5.424  c0.801,0.744,1.536,1.425,2.187,2.03c0.326,0.302,0.63,0.585,0.912,0.846c0.223,0.318,1.14-0.077,1.786-0.258  c1.304-0.374,1.303,0.323,1.436,0.668c0.034,0.441-0.123,0.846-0.123,0.846L248.71,261.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M221.342,266.38c-0.431,0-0.865-0.131-1.241-0.409c-0.93-0.688-1.13-1.997-0.442-2.93l19.907-27.007  c0.685-0.928,1.989-1.135,2.93-0.442c0.93,0.688,1.13,1.997,0.442,2.93l-19.907,27.007  C222.622,266.085,221.986,266.38,221.342,266.38z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "237.295,234.249 247.656,241.118 252.079,234.948 242.417,227.148 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M264.828,231.594l26.551,32.743c0,0,3.732,0.17,3.223-2.799l-27.484-32.234L264.828,231.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF3F5"
    },
    d: "M258.889,236.089c0,0,7.465-1.357,10.603-6.023l4.241,5.005c0,0-6.956,4.92-7.634,10.264  C266.099,245.335,260.417,243.809,258.889,236.089z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M287.561,232.866c-0.488,0-0.957-0.265-1.201-0.726c-0.755-1.431-0.885-2.725-0.387-3.849   c0.697-1.575,2.338-2.036,2.521-2.084c0.74-0.164,1.466,0.254,1.654,0.976c0.186,0.721-0.244,1.458-0.962,1.649   c-0.151,0.048-0.596,0.244-0.737,0.567c-0.133,0.318-0.021,0.843,0.313,1.479c0.35,0.663,0.095,1.484-0.57,1.834   C287.991,232.818,287.776,232.866,287.561,232.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M265.747,253.067c0-0.488-0.265-0.957-0.726-1.201c-1.431-0.755-2.725-0.885-3.849-0.387   c-1.575,0.697-2.036,2.338-2.084,2.521c-0.164,0.74,0.254,1.466,0.975,1.654c0.721,0.186,1.458-0.244,1.649-0.962   c0.048-0.151,0.244-0.596,0.567-0.737c0.318-0.133,0.843-0.021,1.479,0.313c0.663,0.35,1.484,0.095,1.834-0.57   C265.701,253.496,265.747,253.282,265.747,253.067z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAF3F5"
    },
    points: "288.466,229.812 263.47,254.355 269.352,260.915 293.781,236.259 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE3C"
    },
    d: "M161.508,194.435c1.674-0.388,3.143,1.863,1.63,3.492s-5.887,4.574-7.218,4.307  C153.59,201.769,151.962,196.647,161.508,194.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M351.159,196.792c-1.553-0.388-2.914,1.863-1.511,3.492s5.458,4.574,6.692,4.307  C358.499,204.126,360.009,199.004,351.159,196.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M294.005,219.581c2.094,0,3.792,1.811,3.792,4.044v46.247c0,11.176-5.239,50.292-41.91,61.468  c-36.671-11.176-41.91-50.292-41.91-61.468v-46.247c0-2.233,1.698-4.044,3.792-4.044H294.005 M294.005,216.787H217.77  c-3.631,0-6.586,3.068-6.586,6.838v46.247c0,2.67,0.36,16.757,7.467,31.92c7.556,16.12,20.151,27.261,36.422,32.22l0.814,0.248  l0.814-0.248c16.271-4.959,28.866-16.1,36.422-32.22c7.107-15.163,7.467-29.25,7.467-31.92v-46.247  C300.591,219.854,297.638,216.787,294.005,216.787L294.005,216.787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF3F5"
    },
    d: "M322.977,331.995c-11.874-3.98-24.613-2.143-36.627,5.872  c-15.356,10.237-25.536,10.237-30.428,10.237s-15.072,0-30.428-10.237c-12.012-8.01-24.756-9.849-36.627-5.872v11.979  c7.481-3.576,18.028-5.072,30.428,3.192c18.172,12.115,31.105,12.115,36.627,12.115c5.522,0,18.456,0,36.627-12.115  c12.401-8.273,22.947-6.772,30.428-3.194V331.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M255.921,395.602c-78.57,0-142.493-63.923-142.493-142.493s63.923-142.493,142.493-142.493  s142.493,63.923,142.493,142.493S334.491,395.602,255.921,395.602z M255.921,116.203c-75.489,0-136.905,61.413-136.905,136.905  s61.416,136.905,136.905,136.905S392.826,328.6,392.826,253.108S331.41,116.203,255.921,116.203z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M100.04,264.983c0,0-0.582-17.462,16.182-17.462c0,0,0.349,6.869-5.704,9.895   C105.622,259.863,100.04,264.983,100.04,264.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M132.407,264.983c0,0,0.582-17.462-16.182-17.462c0,0-0.349,6.869,5.704,9.895   C126.825,259.863,132.407,264.983,132.407,264.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M411.686,247.521c0,0,0.582,17.462-16.182,17.462c0,0-0.349-6.869,5.704-9.895   C406.103,252.64,411.686,247.521,411.686,247.521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M379.318,247.521c0,0-0.582,17.462,16.182,17.462c0,0,0.349-6.869-5.704-9.895   C384.901,252.64,379.318,247.521,379.318,247.521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M264.594,412.075c0,0-17.462,0.582-17.462-16.182c0,0,6.869-0.349,9.895,5.704   C259.474,406.492,264.594,412.075,264.594,412.075z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M264.594,379.707c0,0-17.462-0.582-17.462,16.182c0,0,6.869,0.349,9.895-5.704   C259.474,385.29,264.594,379.707,264.594,379.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M247.132,100.429c0,0,17.462-0.582,17.462,16.182c0,0-6.869,0.349-9.895-5.704   C252.251,106.011,247.132,100.429,247.132,100.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M247.132,132.796c0,0,17.462,0.582,17.462-16.182c0,0-6.869-0.349-9.895,5.704   C252.251,127.214,247.132,132.796,247.132,132.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M151.853,372.609c0,0-12.759-11.936-0.906-23.79c0,0,5.104,4.61,2.963,11.031   C152.18,365.042,151.853,372.609,151.853,372.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M174.741,349.722c0,0-11.936-12.759-23.79-0.906c0,0,4.61,5.104,11.031,2.963   C167.173,350.049,174.741,349.722,174.741,349.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M359.871,139.895c0,0,12.759,11.936,0.905,23.79c0,0-5.104-4.61-2.963-11.031   C359.544,147.462,359.871,139.895,359.871,139.895z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M336.984,162.782c0,0,11.936,12.759,23.79,0.906c0,0-4.61-5.104-11.031-2.963   C344.552,162.454,336.984,162.782,336.984,162.782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M372.22,360.261c0,0-11.936,12.759-23.79,0.906c0,0,4.61-5.104,11.031-2.963   C364.652,359.934,372.22,360.261,372.22,360.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M349.332,337.374c0,0-12.759,11.936-0.906,23.79c0,0,5.104-4.61,2.963-11.031   C349.66,344.942,349.332,337.374,349.332,337.374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M139.506,152.242c0,0,11.936-12.759,23.79-0.906c0,0-4.61,5.104-11.031,2.963   C147.073,152.57,139.506,152.242,139.506,152.242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M162.393,175.13c0,0,12.759-11.936,0.906-23.79c0,0-5.104,4.61-2.963,11.031   C162.064,167.562,162.393,175.13,162.393,175.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M115.243,323.949c0,0-7.22-15.91,8.267-22.326c0,0,2.951,6.212-1.483,11.325   C118.441,317.083,115.243,323.949,115.243,323.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M145.146,311.563c0,0-6.145-16.356-21.633-9.941c0,0,2.306,6.479,9.057,6.959   C138.029,308.969,145.146,311.563,145.146,311.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M396.483,188.554c0,0,7.22,15.91-8.267,22.326c0,0-2.951-6.212,1.483-11.325   C393.285,195.421,396.483,188.554,396.483,188.554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M366.579,200.941c0,0,6.145,16.356,21.633,9.941c0,0-2.306-6.479-9.057-6.959   C373.695,203.534,366.579,200.941,366.579,200.941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M323.56,396.872c0,0-15.91,7.22-22.326-8.267c0,0,6.212-2.951,11.325,1.483   C316.694,393.674,323.56,396.872,323.56,396.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M311.173,366.969c0,0-16.356,6.145-9.941,21.633c0,0,6.479-2.306,6.959-9.057   C308.579,374.085,311.173,366.969,311.173,366.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M188.165,115.632c0,0,15.91-7.22,22.326,8.267c0,0-6.212,2.951-11.325-1.483   C195.032,118.83,188.165,115.632,188.165,115.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M200.551,145.535c0,0,16.356-6.145,9.941-21.633c0,0-6.479,2.306-6.959,9.057   C203.145,138.418,200.551,145.535,200.551,145.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M204.299,403.555c0,0-16.356-6.145-9.941-21.633c0,0,6.479,2.306,6.959,9.057   C201.704,396.438,204.299,403.555,204.299,403.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M216.685,373.651c0,0-15.91-7.22-22.326,8.267c0,0,6.212,2.951,11.325-1.483   C209.818,376.849,216.685,373.651,216.685,373.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M307.427,108.949c0,0,16.356,6.145,9.941,21.633c0,0-6.479-2.306-6.959-9.057   C310.021,116.066,307.427,108.949,307.427,108.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M295.04,138.853c0,0,15.91,7.22,22.326-8.267c0,0-6.212-2.951-11.325,1.483   C301.906,135.654,295.04,138.853,295.04,138.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M403.165,307.816c0,0-6.145,16.356-21.633,9.941c0,0,2.306-6.479,9.057-6.959   C396.048,310.41,403.165,307.816,403.165,307.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M373.262,295.43c0,0-7.22,15.91,8.267,22.326c0,0,2.951-6.212-1.483-11.325   C376.461,302.296,373.262,295.43,373.262,295.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M108.56,204.688c0,0,6.145-16.356,21.633-9.941c0,0-2.306,6.479-9.057,6.959   C115.677,202.094,108.56,204.688,108.56,204.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M138.464,217.074c0,0,7.22-15.91-8.268-22.326c0,0-2.951,6.212,1.483,11.325   C135.264,210.208,138.464,217.074,138.464,217.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M104.737,295.215c0,0-3.978-17.013,12.464-20.284c0,0,1.683,6.668-3.664,10.818   C109.214,289.105,104.737,295.215,104.737,295.215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M136.482,288.9c0,0-2.836-17.24-19.278-13.97c0,0,0.997,6.805,7.525,8.592   C130.008,284.968,136.482,288.9,136.482,288.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M406.987,217.289c0,0,3.978,17.013-12.464,20.284c0,0-1.683-6.668,3.664-10.818   C402.512,223.399,406.987,217.289,406.987,217.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M375.242,223.603c0,0,2.836,17.24,19.278,13.97c0,0-0.997-6.805-7.525-8.592   C381.716,227.535,375.242,223.603,375.242,223.603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M294.826,407.377c0,0-17.013,3.978-20.284-12.464c0,0,6.668-1.683,10.818,3.664   C288.716,402.901,294.826,407.377,294.826,407.377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M288.51,375.632c0,0-17.24,2.836-13.97,19.278c0,0,6.805-0.997,8.592-7.525   C284.578,382.106,288.51,375.632,288.51,375.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M216.9,105.126c0,0,17.013-3.978,20.284,12.464c0,0-6.668,1.683-10.818-3.664   C223.01,109.603,216.9,105.126,216.9,105.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M223.215,136.872c0,0,17.24-2.836,13.97-19.278c0,0-6.805,0.997-8.592,7.525   C227.146,130.398,223.215,136.872,223.215,136.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M176.551,390.665c0,0-14.843-9.218-5.529-23.156c0,0,5.905,3.526,5.059,10.241   C175.396,383.179,176.551,390.665,176.551,390.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M194.534,363.752c0,0-14.196-10.186-23.51,3.753c0,0,5.517,4.106,11.397,0.755   C187.176,365.549,194.534,363.752,194.534,363.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M335.173,121.839c0,0,14.843,9.218,5.529,23.156c0,0-5.905-3.526-5.059-10.241   C336.328,129.325,335.173,121.839,335.173,121.839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M317.19,148.752c0,0,14.196,10.186,23.51-3.753c0,0-5.517-4.106-11.397-0.755   C324.549,146.954,317.19,148.752,317.19,148.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M390.276,335.563c0,0-9.218,14.843-23.156,5.529c0,0,3.526-5.905,10.241-5.059   C382.789,336.718,390.276,335.563,390.276,335.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M363.362,317.58c0,0-10.186,14.196,3.753,23.51c0,0,4.106-5.517,0.755-11.397   C365.16,324.938,363.362,317.58,363.362,317.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M121.45,176.941c0,0,9.218-14.843,23.156-5.529c0,0-3.526,5.905-10.241,5.059   C128.936,175.786,121.45,176.941,121.45,176.941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M148.363,194.923c0,0,10.186-14.196-3.753-23.51c0,0-4.106,5.517-0.755,11.397   C146.564,187.565,148.363,194.923,148.363,194.923z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M131.152,350.082c0,0-10.186-14.196,3.753-23.51c0,0,4.106,5.517,0.755,11.397   C132.949,342.724,131.152,350.082,131.152,350.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M158.064,332.1c0,0-9.218-14.843-23.156-5.529c0,0,3.526,5.905,10.241,5.059   C150.577,330.944,158.064,332.1,158.064,332.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M380.574,162.422c0,0,10.186,14.196-3.753,23.51c0,0-4.106-5.517-0.755-11.397   C378.776,169.78,380.574,162.422,380.574,162.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M353.661,180.404c0,0,9.218,14.843,23.156,5.529c0,0-3.526-5.905-10.241-5.059   C361.147,181.559,353.661,180.404,353.661,180.404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M349.693,380.963c0,0-14.196,10.186-23.51-3.753c0,0,5.517-4.106,11.397-0.755   C342.335,379.166,349.693,380.963,349.693,380.963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M331.711,354.051c0,0-14.843,9.218-5.529,23.156c0,0,5.905-3.526,5.059-10.241   C330.556,361.536,331.711,354.051,331.711,354.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M162.033,131.541c0,0,14.196-10.186,23.51,3.753c0,0-5.517,4.106-11.397,0.755   C169.391,133.338,162.033,131.541,162.033,131.541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M180.014,158.453c0,0,14.843-9.218,5.529-23.156c0,0-5.905,3.526-5.059,10.241   C181.17,150.967,180.014,158.453,180.014,158.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M234.027,410.784c0,0-17.24-2.836-13.97-19.278c0,0,6.805,0.997,8.592,7.525   C230.094,404.31,234.027,410.784,234.027,410.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M240.34,379.039c0,0-17.013-3.978-20.284,12.464c0,0,6.668,1.683,10.818-3.664   C234.23,383.515,240.34,379.039,240.34,379.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M277.699,101.72c0,0,17.24,2.836,13.97,19.278c0,0-6.805-0.997-8.592-7.525   C281.63,108.194,277.699,101.72,277.699,101.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M271.384,133.465c0,0,17.013,3.978,20.284-12.464c0,0-6.668-1.683-10.818,3.664   C277.495,128.989,271.384,133.465,271.384,133.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M410.395,278.088c0,0-2.836,17.24-19.278,13.97c0,0,0.997-6.805,7.525-8.592   C403.921,282.02,410.395,278.088,410.395,278.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M378.65,271.773c0,0-3.978,17.013,12.464,20.284c0,0,1.683-6.668-3.664-10.818   C383.125,277.884,378.65,271.773,378.65,271.773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M101.331,234.416c0,0,2.836-17.24,19.278-13.97c0,0-0.997,6.805-7.525,8.592   C107.805,230.484,101.331,234.416,101.331,234.416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M133.076,240.73c0,0,3.978-17.013-12.464-20.284c0,0-1.683,6.668,3.664,10.818   C128.6,234.62,133.076,240.73,133.076,240.73z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBz);
export default __webpack_public_path__ + "static/media/bz.bea8656cfa8a403f95bbce8216af8d75.svg";
export { ForwardRef as ReactComponent };